export default __webpack_public_path__ + "static/media/edit.e804fc33.svg";